import { render, staticRenderFns } from "./contact-edit-widget.vue?vue&type=template&id=6da83ae7&scoped=true&"
import script from "./contact-edit-widget.vue?vue&type=script&lang=js&"
export * from "./contact-edit-widget.vue?vue&type=script&lang=js&"
import style0 from "./contact-edit-widget.vue?vue&type=style&index=0&id=6da83ae7&scoped=true&lang=css&"
import style1 from "./contact-edit-widget.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da83ae7",
  null
  
)

export default component.exports